import React, {
    useEffect,
    useState,
    useRef,
    useContext
} from "react";
import {
    Row,
    Col,
    useProTableOt,
    ProTableOt,
    Button,
    Typography,
    Form,
    message,
    Modal,
    setParamsFilter,
    Select,
    InputNumber,
} from "../../../ui/ot";
import { useCRUDController } from "../../../ui/classify_structure/CRUDController"
import { useLibrary } from '../../controllers/LibraryController'
import { useTranslation } from "react-i18next";
import { LibraryContext } from "../library_context";
import axios from 'axios'
const LibraryTransferManagement = (
    permission_level = null, 
) => {
    return (
        <Row>
            <Col span={24}>
                <LibraryTransferManagementTable keyPrefix={'library.backstage.library_transfer_management'} permission_level={permission_level} />
            </Col>
        </Row>
    )
}
const LibraryTransferManagementTable = ({
    keyPrefix = 'library.backstage.library_transfer_management',
    rowKey = 'branchtransfer_id',
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const { branchcode, branchname } = useContext(LibraryContext);

    const actionRef = useRef(null);
    const columns = [
        {
            title: t('transfer_out_date'),
            dataIndex: "datesent",
            key: "datesent",
        },
        {
            title: t('bibliography'),
            dataIndex: "bib_title",
            key: "bib_title",
            width: 100,
            render: (text, record, index) => {
                return <Row>
                    <Col span={24}>
                        <Typography.P>
                            {record?.bib_title}{record?.bib_subtitle} 
                        </Typography.P>
                    </Col>
                </Row>
            }

        },
        {
            title: t('barcode'),
            dataIndex: "item_barcode",
            key: "item_barcode",
        },
        {
            title: t('call_number'),
            dataIndex: "item_itemcallnumber",
            key: "item_itemcallnumber",
        },
        {
            title: t('transfer_out_library'),
            dataIndex: "item_branchname_transfer_from",
            key: "item_branchname_transfer_from",
        },
        {
            title: t('transfer_in_library'),
            dataIndex: "item_branchname_transfer_to",
            key: "item_branchname_transfer_to",
        },
        // {
        //     title: t('received_date'),
        //     dataIndex: "received_date",
        //     key: "received_date",
        // },
        // {
        //     title: t('is_reserved'),
        //     dataIndex: "is_reserved",
        //     key: "is_reserved",
        // },


    ];
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([]);
    const [extra_columns, set_extra_columns] = useState([]);
    const [axiosMode, setAxiosMode] = useState("get");
    const [modalOpen, setModalOpen] = useState(false);
    const [searchParams, setSearchParams] = useState({
        "frombranch": null,
        "tobranch": branchcode
    });
    const [modalLoading, setModalLoading] = useState(false);
    const [form] = Form.useForm();
    const rowSelection = {
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value?.[rowKey]);
                    selectRow.push(value);
                });
            } else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value?.[rowKey]);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);
                });
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [];
            let selectRow = [];
            select_temp = [...selectedRowKeys];
            selectRow = [...selectedRowsInfo];

            if (selected) {
                select_temp.push(record?.[rowKey]);
                selectRow.push(record);
            } else {
                select_temp = select_temp.filter(
                    (key) => key !== record?.[rowKey]
                );
                selectRow = selectRow.filter(
                    (row) => row?.[rowKey] !== record?.[rowKey]
                );
            }
            setSelectedRowKeys(select_temp);
            setSelectedRowsInfo(selectRow);
        },

    };

    const onFinish = ({ axiosMode, status, values }) => {

        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.success(t('receive_success'));
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([]);
                setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('receive_failure'));
                actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            setModalLoading(false);
            setModalOpen(false);
        }
    };
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    };
    const getExcel = () => {
        axios.get('/library/koha/item/transfer/export/excel', {
            responseType: 'blob',
            params: {
                cur_page: 1,
                size: 1000,
                ...searchParams
            }
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `分館轉移.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    };
    const {

        getData,
        postData,
        patchData,
        deleteData,
        ResponseData,
    } = useCRUDController({
        apiRoute: "/koha/item/transfer",
        onFinish,
        onBefore,
    });
    const libraryController = useCRUDController({
        apiRoute: "/koha/library",
        onFinish,
        onBefore,
    });

    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    useEffect(() => {
        checkAll();
        libraryController.getData({})
        console.log({
            branchcode
        })
    }, []);
    useEffect(() => {
        setSearchParams((pre) => {
            return {
                "frombranch": null,
                "tobranch": branchcode
            }
        })
    }, [branchcode])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [searchParams])
    return (
        <Row gutter={[8, 8]}>

            <Col span={24}>
                <ProTableOt
                    formMode={true}
                    searchParams={searchParams}
                    rowKey={rowKey}
                    actionRef={actionRef}
                    columns={columns}
                    check={check}
                    setCheck={setCheck}
                    headerTitle={<Col span={24}>
                        <Row gutter={[4, 4]} >
                            <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                                <Row gutter={[2, 2]} align="middle">
                                    <Col>
                                        {t(`transfer_out_library`)}：
                                    </Col>
                                    <Col span={24}>
                                        <Select
                                            defaultValue={searchParams?.frombranch}
                                            value={searchParams?.frombranch}
                                            allowClear={true}
                                            options={libraryController?.ResponseData.map((value) => {
                                                return {
                                                    label: value?.branchname,
                                                    value: value?.branchcode
                                                }
                                            })}
                                            onChange={(val) => {
                                                setSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        frombranch: val
                                                    }
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={24}>
                                <Row gutter={[2, 2]} align="middle">
                                    <Col>
                                        {t(`transfer_in_library`)}：
                                    </Col>
                                    <Col span={24}>
                                        <Select
                                            allowClear={true}
                                            defaultValue={searchParams?.tobranch}
                                            value={searchParams?.tobranch}
                                            options={libraryController?.ResponseData.map((value) => {
                                                return {
                                                    label: value?.branchname,
                                                    value: value?.branchcode
                                                }
                                            })}
                                            onChange={(val) => {
                                                setSearchParams((pre) => {
                                                    return {
                                                        ...pre,
                                                        tobranch: val
                                                    }
                                                })
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>}
                    request={async (params = {}, sort, filter) => {
                        let newParams = {};
                        let order = setOrders(sort);
                        newParams = {
                            ...params,
                            ...newParams,
                            order,
                            size: params.pageSize,
                            cur_page: params.current,
                            custom_filter_value: params.keyword ?? "",
                            custom_filter_key: custom_filter_key,
                            ...searchParams
                        };
                        newParams = setParamsFilter({
                            ...newParams,
                        });

                        return getData({
                            ...newParams,
                        });

                    }}
                    toolBarRender={() => {
                        return [
                            <Button
                                type='text'
                                style={{
                                    color: "#fff",
                                    backgroundColor: "#56b673"
                                }}
                                onClick={() => {
                                    getExcel()
                                }}
                            >
                                匯出檔案
                            </Button>,
                        ];
                    }}
                    rowSelection={{
                        type: "checkbox",
                        selectedRowKeys: selectedRowKeys,
                        ...rowSelection,
                    }}
                    extra_columns={extra_columns}
                    set_extra_columns={set_extra_columns}
                    manage_columns={true}
                    propsPatchOnBefore={(record) => {
                        return { ...record }
                    }}
                    PropsPatchForm={<LibraryTransferManagementForm

                    />}
                    propsUseData={() => {
                        return {
                            postData: (data) => {
                                let newData = data?.map((val) => {
                                    return {
                                        ...val,
                                        // biblionumber: bib_biblionumber,
                                        // biblio_id:bib_biblionumber
                                    }
                                })
                                postData(newData)
                            },
                            patchData: patchData,
                            deleteData: (data) => {
                                console.log({ data })
                                let newdeleteData = data?.map((val) => {
                                    return {
                                        ...val,
                                        itemnumber: val?.item_itemnumber,
                                    }
                                })
                                deleteData(newdeleteData)
                            },
                        }
                    }}
                    propsPatch={false}
                    propsPatchProcess={(record) => {
                        // let newRecord = transformData(record)
                        return { ...record }
                    }}
                    modalOpen={modalOpen}
                    setModalOpen={setModalOpen}
                    propsDelete={false}
                    propsPatchOnFinish={({ axiosMode, status }) => {
                        if (status === "success") {
                            actionRef.current.reload()
                        } else {

                        }
                    }}

                    propsPost={permission_level?.permission_level === 1 ? true : false}
                    // propsPostOnBefore
                    initialValues={{}}
                    propsWidth={1000}
                    extraActionRender={(record) => {
                        return <Row gutter={[8, 8]} wrap={false}>
                            <Col>
                                <Button
                                    onClick={() => {
                                        deleteData([
                                            {
                                                itemnumber: record.item_itemnumber
                                            }
                                        ])
                                    }}
                                    disabled={!!record?.received_date} size={"small"} >
                                    確認接收
                                </Button>
                            </Col>
                        </Row>
                    }}
                />
            </Col>
        </Row>
    );
};

const LibraryTransferManagementForm = (
    {
        keyPrefix = 'library.backstage.library_transfer_management',
        propsForm,
        field,
        initialValues,
        onFormFinish = () => { },

    }) => {
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const { t } = useTranslation('translation', { keyPrefix })
    const [transferInLibraryOptions, setTransferInLibraryOptions] = useState([])
    const [transferOutLibraryOptions, setTransferOutLibraryOptions] = useState([])

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getLibraryData({

        }).then((response) => {
            let data = response?.data || []
            let options = data.map((value) => {
                return {
                    label: value?.branchname,
                    value: value?.branchcode
                }
            })
            setTransferInLibraryOptions(options)
            setTransferOutLibraryOptions(options)
        })
    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };

    const {
        getLibraryData
    } = useLibrary({
    });
    useEffect(() => {
        setDataInitialization();
    }, []);


    return (
        <Row>
            <Col span={24}
            >
                <Form
                    form={form}
                    onValuesChange={(value, { name, type }) => {
                        console.log({
                            value
                        })
                    }}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                transferInLibraryOptions={transferInLibraryOptions}
                                transferOutLibraryOptions={transferOutLibraryOptions}
                                keyPrefix={keyPrefix}
                                field={field}
                                initialValues={initialValues}
                            />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    );

}
const FormItemComponent = ({
    keyPrefix,
    field,
    initialValues = {},
    transferInLibraryOptions,
    transferOutLibraryOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[16, 16]}>
            <Col>
                <Form.Item
                    labelCol={4}
                    wrapperCol={20}
                    {...field}
                    name={[field?.name ?? '', 'branchtransfer_id']}
                    fieldKey={[field?.fieldKey ?? '', 'branchtransfer_id'].join('.')}
                >
                    <div></div>
                </Form.Item>
            </Col>

            {/* <Col span={24}>
                        <Form.Item
                            {...field}
                            label={t(`transfer_out_library`)}
                            name={[field?.name ?? '', 'barcode']}
                            fieldKey={[field?.fieldKey ?? '', 'barcode'].join('.')}
                            rules={[{ required: true, message: t('please_enter') }]}

                        >
                            <Select options={transferOutLibraryOptions} />
                        </Form.Item>
                    </Col> */}
            <Col span={24}>
                <Form.Item
                    {...field}
                    label={t(`barcode`)}
                    name={[field?.name ?? '', 'barcode']}
                    fieldKey={[field?.fieldKey ?? '', 'barcode'].join('.')}
                    rules={[{ required: true, message: t('please_enter') }]}
                >
                    <InputNumber />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    {...field}
                    label={t(`transfer_in_library`)}
                    name={[field?.name ?? '', 'tobranch']}
                    fieldKey={[field?.fieldKey ?? '', 'tobranch'].join('.')}
                    rules={[{ required: true, message: t('please_enter') }]}
                >
                    <Select options={transferInLibraryOptions} />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default LibraryTransferManagement
export { LibraryTransferManagementTable, LibraryTransferManagementForm }
